<template>

    <button v-if="as == 'button'"
        class="transition text-white px-4 py-2.5 md-h:py-3 rounded text-sm text-left relative 3xl:text-lg"
        style="width: available;"
        :class="{
            'bg-blue': active,
            'hover:bg-blue': ! active,
        }">

        <slot></slot>

    </button>

    <Link v-else
        :href="href"
        class="transition text-white px-4 py-2.5 md-h:py-3 rounded text-sm relative 3xl:text-lg"
        :class="{
            'bg-blue': active,
            'hover:bg-blue': ! active,
        }">

        <slot></slot>

    </Link>

</template>

<script>
import { defineComponent } from 'vue'
import { Link } from '@inertiajs/inertia-vue3';

export default defineComponent({

    props: {
        href: String,
        as: String
    },

    components: {
        Link,
    },

    computed: {

        active() {

            return location.href.indexOf( this.href ) === 0;

        }

    }

});
</script>
